[
  {
    "n": 1,
    "name": "The Iron Pact",
    "bannerId": "ledger.eras.iron_pact",
    "headline": "Baseline. No variant. Learn the numbers."
  },
  {
    "n": 2,
    "name": "The Docks War",
    "bannerId": "ledger.eras.docks_war",
    "headline": "Six new district chains ship. Territory raids pay double Legend."
  },
  {
    "n": 3,
    "name": "The Harbor Accord",
    "bannerId": "ledger.eras.harbor_accord",
    "headline": "Sit-Downs are binding. Breaking one triggers an automatic 24 hour Indictment hold."
  },
  {
    "n": 4,
    "name": "The Long Winter",
    "bannerId": "ledger.eras.long_winter",
    "headline": "Dry Season. Laundering caps at 65 percent, the street fence is closed, and dirty cash spends only through Family infrastructure."
  },
  {
    "n": 5,
    "name": "The Bell Foundry Strike",
    "bannerId": "ledger.eras.bell_foundry_strike",
    "headline": "Territory income halved, Contract payouts doubled. The Era where money comes from people, not places."
  },
  {
    "n": 6,
    "name": "The Reckoning",
    "bannerId": "ledger.eras.reckoning",
    "headline": "The Open Ledger. Nothing is anonymous for one Era, every action is publicly attributed, and any player may file Testimony against a name."
  }
]
